import React, { Component, Fragment } from 'react';
import { compose } from '../../reactApolloCompat';
import { withRouter } from '../../utils/withRouter';
import gql from 'graphql-tag';
import withStyles from '@mui/styles/withStyles';
import Grid from '../../components/layout/Grid';
import Paper from '../../components/layout/Paper';
import Button from '../../components/form/Button';
import ViewHeader from '../../components/header/ViewHeader';
import DataTable from '../../components/dataTable/DataTable';
import AttentionDot from '../../components/table/AttentionDot';
import { joinDefined, PAGE_PLAQUES, prettyPhone } from '../../utils/strings';
import { niceTimeFromString, shortDateFromString } from '../../utils/date';
import ErrorFallback from '../../components/ErrorFallback';
import { withErrorBoundary } from '@sentry/react';

class PlaqueListing extends Component {
    render() {
        return (
            <Grid container className="sticky-table">
                <Grid item>{this.renderHeader()}</Grid>
                <Grid item>
                    <Paper elevation={0}>
                        <Grid item>{this.renderPlaqueListingsTable()}</Grid>
                    </Paper>
                </Grid>
            </Grid>
        );
    }

    renderHeader() {
        return <ViewHeader title="Plaques" />;
    }

    renderPlaqueListingsTable() {
        return (
            <Fragment>
                <Grid item>
                    <Grid container>
                        <Grid item>
                            <DataTable
                                dataObject="PlaqueOrder"
                                queryName="readPlaqueOrders"
                                fragment={plaqueFragment}
                                isFilterable={['Status']}
                                isSortable
                                columns={plaqueColumns}
                                variables={{ filterBy: [] }}
                                searchVariable="contains"
                                noFiltersTitle="Only Current Orders"
                                showFlags={['urgent']}
                                persistVariablesKey="Plaques"
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Fragment>
        );
    }
}

const plaqueColumns = [
    {
        label: 'Ref',
        propertyPath: 'LegacyKey',
        renderCell: (row, value) =>
            <Button href={PAGE_PLAQUES + value + `/${row.ID}`} variant="link-orange">
                {value || row.ID}
            </Button>
    },
    {
        label: 'Deceased',
        propertyPath: 'Deceased.Surname',
        renderCell: row => <>{row.NameOfDeceased}</>
    },
    {
        label: 'Installation Date',
        propertyPath: 'InstallationDate',
        renderCell: row => <>{shortDateFromString(row.InstallationDate)}</>

    },
    {
        label: 'Status',
        propertyPath: 'Status',
        renderCell: (row, value) => {
            const urgent = row.Status === 'Urgent' || row.Status === 'Overdue';
            const ignore = !!row.Cancelled || !!row.Complete;
            return (
                <>
                    <div className="attention-list">
                        {(!ignore && (!!urgent) && <AttentionDot variant="urgent" />)}
                    </div>
                    {value}
                </>
            );
        }
    },
    {
        label: 'Plaque Type',
        renderCell: row => <>{row.ProductOrder && row.ProductOrder.Product && row.ProductOrder.Product.Title}</>
    },
    {
        label: 'Booking Date',
        propertyPath: 'Enquiry.Created',
        renderCell: row => <>{shortDateFromString(row.Enquiry.Created)}<br />{niceTimeFromString(row.Enquiry.Created)}</>

    },
    {
        label: 'Applicant',
        propertyPath: 'Applicant.Surname',
        renderCell: row => (
            <span>
                {row.Client && joinDefined([row.Client.FirstName, row.Client.MiddleName, row.Client.Surname], ' ')}
                {row.Client &&
                    (row.Client.PrimaryNumber || row.Client.SecondaryNumber) &&
                    (row.Client.FirstName || row.Client.MiddleName || row.Client.Surname) &&
                    <br />}
                {row.Client && prettyPhone(joinDefined([row.Client.PrimaryNumber, row.Client.SecondaryNumber], ' / '), false)}
            </span>
        )
    }
];

const plaqueFragment = gql`
    fragment StylingPlaqueOrder on PlaqueOrder {
        ID
        LegacyKey
        Complete
        Cancelled
        InstallationDate
        InstallationTime
        Status
        NameOfDeceased
        Client {
            ID
            FirstName
            MiddleName
            Surname
            PrimaryNumber
            SecondaryNumber
        }
        Enquiry {
            ID
            Created
        }
        ProductOrder {
            ID
            Product {
                ID
                Title
            }
        }
    }
`;

export default withErrorBoundary(compose(withRouter, withStyles({}))(PlaqueListing), { fallback: ErrorFallback });
export const PlaqueAllListing = withStyles({})(({ ...props }) => {
    return <PlaqueListing {...props} />;
});
